export default __webpack_public_path__ + "static/media/gallery8.da3460ae.jpg";